export default __webpack_public_path__ + "static/media/AdminLightActiveOld.0d8259cb.svg";